/**
 * Invia eventi personalizzati al dataLayer di GTM
 * GTM gestirà poi l'inoltro a DV360 tramite tag configurati
 * 
 *  GTMEvents.trackPurchase(
                clickid,
                transactionId,
                amount,
                context.rateplanScelto?.id || 'unknown'
            );


            6. Configura GTM Container (lato GTM)
Nel tuo account GTM dovrai configurare:

Variabili dataLayer: Crea variabili per catturare i dati dal dataLayer

clickid → Variabile livello dati: clickid
transaction_id → Variabile livello dati: transaction_id
value → Variabile livello dati: value
Trigger: Crea trigger per ogni evento

Tipo: Evento personalizzato
Nome evento: signup_complete, purchase_complete, etc.
Tag DV360 Floodlight: Per ogni conversione

Tipo: Floodlight Counter/Sales
Advertiser ID: Il tuo ID DV360
Activity Group Tag String: signup0, purchase0, etc.
Activity Tag String: compl0, trans0, etc.
Attivazione: Sul trigger corrispondente
 */

/**
 * Push generico al dataLayer
 * @param {object} eventData - Dati dell'evento da inviare a GTM
 */
export function pushToDataLayer(eventData) {
    if (typeof window !== 'undefined' && window.dataLayer) {
        window.dataLayer.push(eventData);
        console.log('GTM Event pushed:', eventData);
    } else {
        console.warn('GTM dataLayer not available');
    }
}

/**
 * Eventi specifici per il funnel di conversione
 */
export const GTMEvents = {
    /**
     * Traccia registrazione utente completata
     */
    add_payment_info: (clickid, email, servizio) => {
        pushToDataLayer({
            event: 'add_payment_info',
            clickid: clickid,
            user_email: email,
            servizio: servizio,
            timestamp: new Date().toISOString()
        });
    },

    /**
     * Traccia acquisto/abbonamento completato
     */
    engaged: (clickid, email, servizio) => {
        pushToDataLayer({
            event: 'engaged',
            clickid: clickid,
            user_email: email,
            servizio: servizio,
            timestamp: new Date().toISOString()
        });
    },
   
    /**
     * Traccia INIZIO PAGAMENTO
     */
    initiate_checkout: (clickid, email, servizio) => {
        pushToDataLayer({
            event: 'initiate_checkout',
            clickid: clickid,
            user_email: email,
            servizio: servizio,
            timestamp: new Date().toISOString()
        });
    },

    /**
     * Traccia la LEAD semplice soi
     */
    lead: (clickid, servizio) => {
        pushToDataLayer({
            event: 'lead',
            clickid: clickid,
            servizio: servizio,
            timestamp: new Date().toISOString()
        });
    },
    
    /**
     * Traccia la LEAD doi confermata
     */
    lead_doi: (clickid, email, servizio) => {
        pushToDataLayer({
            event: 'lead_doi',
            clickid: clickid,
            user_email: email,
            servizio: servizio,
            timestamp: new Date().toISOString()
        });
    },

    /**
     * Traccia acquisto 
     */
    split: (clickid, email, servizio) => {
        pushToDataLayer({
            event: 'split',
            clickid: clickid,
            user_email: email,
            servizio: servizio,
            timestamp: new Date().toISOString()
        });
    },

  
};

export default { pushToDataLayer, GTMEvents };